
export default {
  name: 'ProductListItemVariants',
  props: {
    product: Object,
  },
  computed: {
    totalVariants() {
      return this.product.selectable_variants?.length || 0
    },
    visibleVariants() {
      if (!this.product.selectable_variants) return []
      if (this.totalVariants <= 6) return this.product.selectable_variants
      return this.product.selectable_variants.slice(0, 5)
    },
    remainingCount() {
      if (this.totalVariants <= 6) return 0
      return this.totalVariants - 5
    },
  },
  data() {
    return {
      loadedImages: {},
    }
  },
  methods: {
    isOutsideFilters(variant) {
      return variant.within_technical_ranges === false
    },
    preview(variant) {
      if (!this.isOutsideFilters(variant)) this.$emit('input', variant)
    },
    pick(variant) {
      if (this.$device.isMobile && !this.isOutsideFilters(variant)) {
        this.$emit('input', variant)
      } else {
        this.openProduct({ variant: variant.id, fv: true })
      }
    },
    openProduct(query) {
      this.$emit('navigate')
      this.$router.push(
        this.localePath({
          name: 'produit-slug',
          params: { slug: this.product.slug },
          query,
        })
      )
    },
    onImageLoad(variantId) {
      this.$set(this.loadedImages, variantId, true)
    },
    getVariantUrl(variant_id) {
      return (
        this.$config.url +
        '/produit/' +
        this.product.slug +
        '?variant=' +
        variant_id
      )
    },
  },
}
